/**
 * DEWA Electrical Safety - Avatar Prompts (Arabic)
 *
 * Arabic translations of scripts/prompts for what the avatar says during each module.
 * Mirrors the structure of prompts.js exactly.
 */

export const modulePrompts = {
  'intro-electrical-safety': `مرحباً!   أنا مدرّب السلامة الخاص بك في ديوا.   أهلاً بك في دورة أساسيات السلامة الكهربائية.



السلامة الكهربائية هي أساس كل ما نقوم به في ديوا.   سواء كنت فنياً ميدانياً أو مهندساً أو زائراً للموقع،   فإن فهم المخاطر الكهربائية يمكن أن ينقذ حياتك.



في هذه الوحدة، سنتناول المبادئ الأساسية للسلامة الكهربائية،   بما في ذلك مخاطر الصدمة الكهربائية   والوميض القوسي والانفجار القوسي.



تحدث الصدمة الكهربائية عندما يمر التيار عبر الجسم.   حتى الجهود المنخفضة، التي تصل إلى 50 فولت فقط،   يمكن أن تكون قاتلة في ظروف معينة.



الوميض القوسي هو انطلاق متفجر للطاقة   ناتج عن عطل كهربائي.   يمكن أن تصل درجة حرارته إلى 35,000 درجة فهرنهايت،   وهي أعلى من حرارة سطح الشمس.



مبدأ السلامة الأساسي دائماً هو:   فصل الطاقة، القفل، وضع العلامة، والتحقق   قبل لمس أي معدات كهربائية.



هل أنت مستعد؟   قل "متابعة" عندما تكون جاهزاً لمشاهدة فيديو عن المخاطر الكهربائية.`,

  'electrical-hazards-video': `لنشاهد فيديو يوضح المخاطر الكهربائية الشائعة   ولماذا إجراءات السلامة مهمة جداً.



يرجى المشاهدة بعناية،   وسأكون هنا عند انتهائه.`,

  'quiz-electrical-safety': `ممتاز!   بعد أن تعلّمت أساسيات السلامة الكهربائية،   لنختبر فهمك باختبار سريع.



سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'ppe-site-rules': `لنتحدث الآن عن معدات الوقاية الشخصية   وقواعد دخول الموقع.



معدات الوقاية الشخصية هي خط دفاعك الأخير ضد المخاطر الكهربائية.   في ديوا، نأخذ متطلبات معدات الوقاية الشخصية على محمل الجد.



قبل دخول أي منشأة كهربائية تابعة لديوا، يجب ارتداء:   خوذة أمان مع حزام ذقن،   أحذية أمان معزولة مصنفة للعمل الكهربائي،   سترة عالية الوضوح،   وملابس مقاومة للوميض القوسي مناسبة لمستوى الجهد.



بالنسبة لمناطق الجهد العالي،   قد تحتاج أيضاً إلى قفازات معزولة   ودروع للوجه وبدلات مقاومة للوميض القوسي   مصنفة بمستوى السعرات الحرارية المناسب لكل سنتيمتر مربع.



قواعد دخول الموقع مهمة بنفس القدر.   يجب عليك دائماً:   الحصول على تصريح عمل صالح قبل دخول المناطق المقيدة،   التوقيع في سجل المنشأة،   حضور إحاطة السلامة بالموقع،   وأن يرافقك موظفون مخولون إذا كنت زائراً.



لا تدخل أبداً منطقة كهربائية بمفردك   ما لم تكن مخولاً ويعرف فريقك مكانك.



هل لديك أسئلة عن معدات الوقاية أو قواعد دخول الموقع؟   قل "متابعة" عندما تكون جاهزاً للاختبار.`,

  'quiz-ppe': `ممتاز!   لنختبر الآن معرفتك بمتطلبات معدات الوقاية الشخصية   وإجراءات دخول الموقع.



سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'working-in-substations': `الآن نأتي للوحدة الأكثر أهمية:   العمل بأمان داخل المحطات الفرعية.



تضم محطات ديوا الفرعية محولات عالية الجهد ومعدات تبديل   ومعدات توزيع.   تتراوح الجهود من 11 كيلو فولت إلى 400 كيلو فولت،   مما يجعل الإجراءات السليمة ضرورية للغاية.



قبل أي عمل داخل المحطة الفرعية:   أولاً، تأكد من وجود تصريح عمل صالح.   ثانياً، تحقق من فصل المعدات عن الطاقة باستخدام إجراءات القفل والعلامة.   ثالثاً، اختبر بكاشف جهد معتمد   للتأكد من حالة عدم وجود طاقة.   رابعاً، ضع التأريض الآمن حيثما يلزم.



حافظ على مسافات الاقتراب الآمنة في جميع الأوقات.   لجهد 11 كيلو فولت، ابقَ على بعد 1.5 متر على الأقل.   لجهد 33 كيلو فولت، حافظ على مسافة 3 أمتار.   لجهد 132 كيلو فولت، المسافة 5 أمتار.   ولجهد 400 كيلو فولت، يجب أن تبقى على بعد 8 أمتار على الأقل من الموصلات المكهربة.



في حالة الطوارئ:   قم بالإخلاء فوراً،   نبّه الموظفين القريبين،   وأبلغ غرفة التحكم.   لا تحاول أبداً إطفاء حريق كهربائي بالماء.



تذكر دائماً:   لا توجد مهمة عاجلة لدرجة أنها لا يمكن إنجازها بأمان.



هل لديك أسئلة عن سلامة المحطات الفرعية؟   قل "متابعة" عندما تكون جاهزاً للاختبار النهائي.`,

  'final-quiz': `حسناً!   لقد وصلت إلى الاختبار النهائي.



لنرى كم تعلمت عن السلامة الكهربائية في ديوا.



سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.



مستعد؟   لنبدأ!`,
};

/**
 * Module transition prompts
 */
export const moduleTransitionPrompts = {
  'quiz-electrical-safety': `عمل رائع في إكمال قسم مقدمة السلامة الكهربائية!   أنت الآن تفهم أساسيات المخاطر الكهربائية ومبادئ السلامة.



في القسم التالي،   سنتعلم عن معدات الوقاية الشخصية   وقواعد دخول المنشآت الكهربائية في ديوا.



هل لديك أسئلة عما تناولناه حتى الآن؟   قل "متابعة" عندما تكون جاهزاً للمتابعة.`,

  'quiz-ppe': `ممتاز!   أنت الآن تفهم متطلبات معدات الوقاية الشخصية   وإجراءات دخول المنشآت الكهربائية في ديوا.



في القسم الأخير،   سنستكشف إجراءات السلامة المحددة   للعمل داخل المحطات الفرعية.



هل لديك أسئلة قبل أن ننتقل؟   قل "متابعة" عندما تكون جاهزاً.`,
};

/**
 * Video completion prompts
 */
export const videoCompletionPrompts = {
  'electrical-hazards-video': `كانت تلك نظرة عامة مهمة على المخاطر الكهربائية!



أتمنى أن تكون قد وجدتها مفيدة.   إذا كان لديك أي أسئلة حول ما شاهدته،   لا تتردد في السؤال.   إذا كنت ترغب في مشاهدة الفيديو مرة أخرى،   قل "أعد الفيديو".



عندما تكون جاهزاً لاختبار سريع حول أساسيات السلامة الكهربائية،   قل "متابعة".`,
};

/**
 * Course completion prompt
 */
export const courseCompletionPrompt = `تهانينا!   لقد أكملت دورة أساسيات السلامة الكهربائية في ديوا!



أنت الآن تفهم المبادئ الحيوية للسلامة الكهربائية،   ومتطلبات معدات الوقاية الشخصية لمنشآت ديوا،   وإجراءات العمل بأمان داخل المحطات الفرعية.



تذكر:   السلامة ليست مجرد مجموعة من القواعد،   إنها عقلية.   افصل الطاقة دائماً قبل العمل،   ارتدِ معدات الوقاية المناسبة،   اتبع إجراءات تصريح العمل،   ولا تتخذ اختصارات أبداً مع السلامة الكهربائية.



شكراً لك على إكمال هذا التدريب.   ابقَ آمناً، وإذا كان لديك أي شكوك،   توقف واسأل.   لا توجد مهمة تستحق المخاطرة بحياتك.



بالتوفيق في عملك في ديوا!`;

export const welcomeMessage = "مرحباً! أهلاً بك في دورة السلامة في مكان العمل. أنا ذكاء اصطناعي وسأقوم بإرشادك خلال هذه الدورة. لا تتردد في التوقف وطرح أي أسئلة في أي وقت. لنبدأ!";

const dewaPromptsAr = {
  modulePrompts,
  moduleTransitionPrompts,
  videoCompletionPrompts,
  courseCompletionPrompt,
  welcomeMessage,
};

export default dewaPromptsAr;
